module.exports = __webpack_public_path__ + "img/add-colored.a07c3299.svg";